


























































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {BlacklistGlobalItem} from "@/store/settings/blacklists/types";
import {ActionLog} from "@/store/auth/types";

@Component({components: {ScrollButton}})
export default class BlackListGenerals extends BaseItemsPage<BlacklistGlobalItem> {
  @Action("actionLog") actionLog: any;
  @Action("getBlackListGlobals") actionGetBlackListGlobals: any;
  @Getter("blacklistGlobals") blacklistGlobalsList: BlacklistGlobalItem[] | undefined;

  private logObject: ActionLog = {};
  tableFields = ['channel_name', 'recipients_count'];

  created() {
    this.actionGetBlackListGlobals();
  }

  getData(): BlacklistGlobalItem[] | undefined {
    return  this.blacklistGlobalsList
  }

  changeChannel(val?: string): string {
    if (!val) return '';
    return val.replace(' ', '_').toLowerCase();
  }
}
